var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layoutPage", [
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _vm.notification
          ? _c("app-modal-notificacao", {
              attrs: {
                idUsuario: _vm.usuario.id,
                notificacao: _vm.notification
              },
              on: {
                closeModal: function($event) {
                  return _vm.closeModal()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "main",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "container"
          },
          [
            _vm.usuario
              ? _c(
                  "el-row",
                  {
                    staticClass: "container",
                    attrs: { type: "flex", justify: "center", gutter: 20 }
                  },
                  [
                    _vm.modulos && _vm.modulos.length > 0
                      ? _c("p", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n            Clique sobre o botão correspondente ao módulo que deseja no sistema:\n          "
                          )
                        ])
                      : _c("p", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n            Este usuário não possui acesso a nenhum módulo do sistema.\n          "
                          )
                        ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.usuario
              ? _c(
                  "el-row",
                  {
                    staticClass: "container",
                    attrs: { type: "flex", justify: "center", gutter: 20 }
                  },
                  _vm._l(
                    [].concat(_vm.modulos).sort(function(a, b) {
                      return a.nome > b.nome ? 1 : -1
                    }),
                    function(modulo) {
                      return _c(
                        "el-col",
                        {
                          key: modulo.id,
                          attrs: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card",
                              on: {
                                click: function($event) {
                                  return _vm.setModulo(modulo)
                                }
                              }
                            },
                            [
                              _c(
                                "el-card",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function() {
                                          return [
                                            _c("img", {
                                              staticClass: "perfil",
                                              attrs: {
                                                src: _vm.imgModulo(modulo)
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("span", [_vm._v(_vm._s(modulo.nome))])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }
                  ),
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab88e45e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab88e45e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/selecionar-modulo/selecionar-modulo.vue
// module id = null
// module chunks = 